import { createPortal } from "react-dom";

/**
 * Monta el modal directo en <body>, sin importar en qué parte del JSX se haya
 * escrito.
 *
 * Un `position: fixed` NO se posiciona contra la ventana cuando algún padre
 * tiene transform, filter o una animación de transform: ese padre pasa a ser
 * su bloque contenedor. Las páginas del Portal del residente y las de Agua
 * entran con una animación tipo `...FadeUp .35s ease both`, así que cualquier
 * modal escrito adentro quedaba centrado contra el alto COMPLETO de la página
 * (a media página, fuera de la vista) en vez de contra lo que la persona está
 * viendo — y había que bajar para encontrarlo.
 *
 * Sacándolo a <body> el `inset: 0` vuelve a ser la ventana, en celular y en
 * computadora, sin tener que renunciar a la animación de entrada.
 */
export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
